/* -----------------------------------------------------------------------------------------
    THSI FILE CONTAINS THE IMPORTANT WEB3/UI CONFIGURATIONS FOR THE APP
----------------------------------------------------------------------------------------- */

export const appSettings = {
    /* APP LOGO - LOGO FOR THE DARK VERSION  */
    logo: '/logo.svg',

    /* APP MAIN LOGO WIDTH - CHANGE IT ACCORDING TO YOUR OWN LOGO */
    logoWidth: '100',

    /* APP BRAND NAME - USED IN ALL PAGES & META TAGE - CHANGE TO YOUR OWN BRAND NAME*/
    brandName: 'Bublik Gift',

    /* APP BRAND DESCRIPTION - USED IN HOME PAGE & META TAGS - PUT A SENTENCE THAT DESCRIBE YOUR APP*/
    brandDescription: 'Decentralized Crowdfunding app',

    /* APP AUTHOR - CHANGE IT IF YOU HAVE A LICENSE KEY OR PURCHASE CODE */
    appAuthor: 'Web3 Bublik',

    /* COPYRIGHTS BRAND NAME */
    copyrightsBrand: 'Bublik',

    /* TEXT IDENTIFIER FOR THE NETWORK WHERE THE APP IS UP AND RUNNING, YOU CAN WRITE WHATEVER YOU WANT */
    activeNetworkName: 'BNB Smart Chain Mainnet',

    /* COPYRIGHTS LINK - REPLACE IT IF YOU HAVE A LICENSE KEY OR A PURCHASE CODE */
    copyrightsLink: 'https://bublik.gift',

    /* THE NETWORK RPC URL WHERE YOUR CONTRACTS ARE DEPOLYED ON, CHECK THE EXACT RPC URL FROM HERE https://chainlist.org */
    rpcUrl: 'https://bsc-rpc.publicnode.com',

    /* THE CHAIN ID of NETWORK WHERE YOUR CONTRACTS ARE DEPOLYED ON, GET IT FROM HERE https://chainlist.org */
    networkId: 56,

    /* THE BLOCK SCAN EXPLORER WHRE YOU CAN TRACK THE TRANSACTIONS */
    blockExplorerUrl: 'https://bscscan.com',

    /* THE CURRENT APP CURRENCY THAT YOUR APP WILL APPEAR BESIDES EVERY PRICE */
    currency: 'BNB',

    /* THE NATIVE CURRENCY THAT YOUR APP WILL USE FOR GAS FEES */
    nativeCurrency: 'BNB',

    /* IPFS PROJECT ID */
    IPFSProjectID: '1ad1ed92de91eb93b537',

    /* IPFS PRJECT SECRET KEY */
    IPFSSecret: '0ae7b5dfaf587f2e2cd1e5ec0544509b78f0a87b9327252a5a0bd5e42f05a122',

    /* IPFS DEDICATED GATEWAY NAME */
    IPFSGatewaySubdomain: 'coffee-large-macaw-88.mypinata.cloud',

    /* ENDPOINT FOR ASK FOR A FEATURE FORM */
    newsletterFormId: 'moqzjqva',

    /* WALLET CONNECT PROJECT ID */
    wcProjectId: '1a572183d5a2a65027e3ba3c9e9f3720',

    /* MAX CAMPAIGN DURATION IN DAYS */
    maxDuration: 10,
};
